import { render, staticRenderFns } from "./homeBanner.vue?vue&type=template&id=b4a9045a&scoped=true"
import script from "./homeBanner.vue?vue&type=script&lang=js"
export * from "./homeBanner.vue?vue&type=script&lang=js"
import style0 from "./homeBanner.vue?vue&type=style&index=0&id=b4a9045a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a9045a",
  null
  
)

export default component.exports